import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addProducts: {
    defaultMessage: 'Add products',
    id: 'ZpgJAJ',
    description: 'Add products header text',
  },
  searchProductPlaceholder: {
    defaultMessage: 'Search product name or SKU',
    id: 'M9ZhHJ',
    description: 'Search product placeholder',
  },
  product: {
    defaultMessage: 'Product',
    id: 'OT9ERX',
    description: 'Product column header',
  },
  supplierSKU: {
    defaultMessage: 'Supplier SKU',
    id: 'y23Pt0',
    description: 'Supplier SKU column header',
  },
  unitOfMeasure: {
    defaultMessage: 'UoM',
    id: 'gZbs4c',
    description: 'Unit of Measure column header',
  },
  eaches: {
    defaultMessage: 'Eaches',
    id: '4oyZoE',
    description: 'Eaches column header — total units based on qty × conversion factor',
  },
  qty: {
    defaultMessage: 'Qty',
    id: '5kxziZ',
    description: 'Quantity column header',
  },
  costPerItem: {
    defaultMessage: 'Cost per item',
    id: 'w74XxR',
    description: 'Cost per item column header',
  },
  total: {
    defaultMessage: 'Total',
    id: 'eS2YTT',
    description: 'Total cost column header',
  },
  actions: {
    defaultMessage: 'Actions',
    id: 'Tv9I/4',
    description: 'Actions column header',
  },
  orderedTotal: {
    defaultMessage: 'Ordered Total:',
    id: 'pIi+6G',
    description: 'Label for total cost of all ordered products',
  },
  clearAll: {
    defaultMessage: 'Clear all',
    id: 'HLovO+',
    description: 'Clear all button text',
  },
  productsAdded: {
    defaultMessage: '{count} Product(s) added',
    id: 'pZeujM',
    description: 'Products added text',
  },
  showingProductSummary: {
    defaultMessage: 'Showing {start}-{end} of <b>{total} items</b>',
    id: 'GW8RqN',
    description: 'Showing items text',
  },
  noProductsScanned: {
    defaultMessage: 'Scan your first product to begin adding it to purchase order.',
    id: 'qWjEq0',
    description: 'No products scanned text',
  },
  productSearch: {
    defaultMessage: 'Search product by UPC or SKU',
    id: '13vS6D',
    description: 'Search product by UPC or SKU',
  },
  workWithScanner: {
    defaultMessage: 'If using a scanner, you can continuously scan products without needing to enter each one individually.',
    id: 'wsx+Xm',
    description: 'Text informing how the functionality works with a scanner',
  },
  searchTermError: {
    defaultMessage: 'Search term should be at least 3 characters long',
    id: 'NTSzRF',
    description: 'Search error message for search term too short',
  },
  noSkuOrUpcError: {
    defaultMessage: 'No product found that contains SKU or UPC.',
    id: 'bc9vDj',
    description: 'Error when product is not found by sku or upc',
  },
  searchError: {
    defaultMessage: 'Something went wrong, please try again',
    id: 'AMb7cd',
    description: 'Error when product search throws error',
  },
  uomSkuMatch: {
    defaultMessage: '{sku} · UoM SKU: {uomSku}',
    id: 'WFuAAf',
    description: 'Product SKU with matched UoM SKU shown in search results dropdown',
  },
  uomBarcodeMatch: {
    defaultMessage: '{sku} · UoM Barcode: {uomBarcode}',
    id: 'B9/47u',
    description: 'Product SKU with matched UoM barcode shown in search results dropdown',
  },
  eachesCalculation: {
    defaultMessage: '{total} ({quantity}×{conversionFactor})',
    id: 'm7Ibdu',
    description: 'Eaches column value showing total units and the qty × conversion factor breakdown',
  },
});
